import { createContext, useContext, useMemo, useState } from 'react';
import { getAccessToken, setAccessToken } from '@/lib/api';

const AuthContext = createContext(null);

/**
 * Lightweight auth context for the template shell.
 * Wire login/me queries when connecting real auth flows.
 */
export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => getAccessToken());
  const [user, setUser] = useState(null);

  const value = useMemo(
    () => ({
      user,
      token,
      isAuthenticated: Boolean(token),
      setSession({ accessToken, user: nextUser }) {
        setAccessToken(accessToken);
        setToken(accessToken);
        setUser(nextUser ?? null);
      },
      clearSession() {
        setAccessToken(null);
        setToken(null);
        setUser(null);
      },
      setUser,
    }),
    [token, user],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
